<template>
  <div>
    <div v-if="isExistSearchResult">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th scope="col">企業コード</th>
            <th scope="col">企業名称</th>
            <th scope="col">拠点コード</th>
            <th scope="col">拠点名称</th>
            <th scope="col">作成日</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(value, index) in sectionList" :key="`${index}`">
            <td class="table-cell-wrap mw200 mxw200">{{ value.enterpriseCode }}</td>
            <td class="table-cell-wrap mw200 mxw200">{{ value.enterpriseName }}</td>
            <th class="table-cell-wrap mw250 mxw250" scope="row">
              <router-link :to="{ name: 'section-edit',
                params: { mode: 'update', enterpriseCode: value.enterpriseCode, sectionCode: value.sectionCode }}">
                {{ value.sectionCode }}
              </router-link>
            </th>
            <td class="table-cell-wrap mw250 mxw250">{{ value.sectionName }}</td>
            <td class="table-cell-wrap mw200 mxw200">{{ value.createDateTime | moment('YYYY-MM-DD') }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      検索結果は0件です。
    </div>
  </div>
</template>

<script>
export default {
  name: 'section-search-result',
  props: {
    sectionList: Array,
    isExistSearchResult: false
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/SectionSearchResult.vue